import React, {useEffect} from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";

import {useImmerReducer} from 'use-immer'
import {auth, firestore} from './firebase'

import StateContext from './StateContext'
import DispatchContext from './DispatchContext'

import "./index.css";
import "./assets/css/style.css"
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'

import HomePage from "./pages/HomePage";
import AuthPage from "./pages/AuthPage";
import EditTeamPage from "./pages/EditTeamPage";
import TeamsPage from "./pages/TeamsPage";
import SingleTeamPage from "./pages/SingleTeamPage";
import SinglePlayerPage from "./pages/SinglePlayerPage";
import PlayerDetails from "./components/Admin/Player/PlayerDetails";
import MediaPage from "./pages/MediaPage";
import FixturesPage from "./pages/FixturesPage";

import PostsPage from "./pages/PostsPage";
import SinglePostPage from "./pages/SinglePostPage";
import EditPost from "./components/Admin/Posts/EditPost";
import AddPost from "./components/Admin/Posts/AddPost";
import ProfilePage from "./pages/ProfilePage";

import TransferPage from "./pages/TransferPage";
import AddTransfer from "./components/Admin/Transfers/AddTransfer";
import EditTransfer from "./components/Admin/Transfers/EditTransfer";
import SingleFixturePage from "./pages/SingleFixturePage";
import EditFixturePage from "./pages/EditFixturePage";

import APIDashboardPage from "./pages/APIDashboardPage";
import SingleAlbumPage from "./pages/SingleAlbumPage";
import FixturesAPIPage from "./pages/FixturesAPIPage";
import SingleTeamAPIPage from "./pages/SingleTeamAPIPage";
import SinglePlayerAPIPage from "./pages/SinglePlayerAPIPage";
import FootballAPIPage from "./pages/FootballAPIPage";
import SingleLeagueAPIPage from "./pages/SingleLeagueAPIPage";
import SingleFixtureAPIPage from "./pages/SingleFixtureAPIPage";
import SingleCountry from "./components/Public/FootballAPI/Country/SingleCountry";
import FixturesAPIMainPage from "./pages/FixturesAPIMainPage";
import QuizPage from "./pages/QuizPage";
import SingleQuizPage from "./pages/SingleQuizPage";
import ClubsPage from "./pages/ClubsPage";

// HOSTCUP
import HostcupDashboard from "./components/Hostcup/HostcupAdminFirebase/HostcupDashboard";
import SingleHostcupAdminFirebase from "./components/Hostcup/HostcupAdminFirebase/HostcupDetails/SingleHostcupAdminFirebase";
import SingleRoundHostcupFirebase from "./components/Hostcup/HostcupAdminFirebase/HostcupDetails/SingleRoundHostcupFirebase";
import HostcupPage from "./pages/HostcupPage";
import SingleRoundHostcupFirebasePage from "./pages/SingleRoundHostcupFirebasePage";
import UtenlandsProfferPage from "./pages/UtenlandsProfferPage";
import SingleFootballBlogWp from "./pages/SingleFootballBlogWp";
import FmPage from "./pages/FmPage";

function App() {

    const initialState = {
        loggedIn: false,
        userId: "",
        userData: {
            profile_image: "",
            name: ""
        },
        isAdmin: false,
        flashMessages: [],
        isSearchOpen: false,
        darkBackground: false,
        wordpressSite: "min-kokebok",
        currentPage: "home"
    }

    function ourReducer(draft, action) {
        switch (action.type) {
            case "login":
                draft.loggedIn = true
                draft.userId = action.value
                return
            case "userName":
                draft.userData.name = action.value
                return
            case "isAdmin": 
                draft.isAdmin = true;
                return
            case "userAvatar":
                draft.userData.profile_image = action.value 
                return
            case "logout":
                draft.loggedIn = false
                return
            case "flashMessage":
                draft.flashMessages.push(action.value)
                return 
            case "currentPage":
                draft.currentPage = action.value
                return
            case "openSearch":
                draft.isSearchOpen = true
                return
            case "closeSearch":
                draft.isSearchOpen = false
                return            
            case "openModal":
                draft.darkBackground = true
                return
            case "closeModal":
                draft.darkBackground = false
                return
        }
    }
    const [state, dispatch] = useImmerReducer(ourReducer, initialState);

    useEffect(() => {

        auth.onAuthStateChanged((user) => {
            if (user) {
                dispatch({type: "login", value: user.uid});
            } 
            
        })

    }, [])

    useEffect(() => {

        if (state.loggedIn && state.userId) {

            try {
                const adminRef = firestore.collection("admins").doc(state.userId);
                adminRef.onSnapshot(doc => {
                    const admin = {id: doc.id, ...doc.data()}
                    if (admin) {
                        if (admin.status && admin.status === "approved") {                              
                            localStorage.setItem("adminStatus", "admin")
                            dispatch({type: "isAdmin", value: true})
                        }
                        
                    }
                })

            } catch (error) {
                
            }

        }

    }, [state.loggedIn, state.userId])

    return (
      <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
      <BrowserRouter>
        <Header />
          <Switch>

            <Route path="/" exact>
                <HomePage/>
            </Route>

            <Route path="/innlegg/:page" exact>
                <PostsPage />
            </Route>
            <Route path="/innlegg/single/:id" exact>
                <SinglePostPage />
            </Route>

            <Route path="/innlegg-wp/:id">
                <SingleFootballBlogWp />
            </Route>

            <Route path="/clubs" exact>
                <ClubsPage />
            </Route>
            <Route path="/teams" exact>
                <TeamsPage />
            </Route>
            <Route path="/teams/:id" exact>
                <SingleTeamPage />
            </Route>
            <Route path="/fixtures" exact>
                <FixturesPage />
            </Route>
            <Route path="/fixtures/:id" exact>
                <SingleFixturePage />
            </Route>

            <Route path="/players/:id" exact>
                <SinglePlayerPage />
            </Route>

            <Route path="/transfers" exact>
                <TransferPage />
            </Route>

            <Route path="/quiz" exact>
                <QuizPage />
            </Route>
            <Route path="/quiz/:id" exact>
                <SingleQuizPage />
            </Route>

            <Route path="/football-api" exact>
                <FootballAPIPage />
            </Route>

            <Route path="/leagues/:id" exact>
                <SingleLeagueAPIPage />
            </Route>

            <Route path="/countries/:code" exact>
                <SingleCountry />
            </Route>

            <Route path="/utenlandsproffer" exact>
                <UtenlandsProfferPage />
            </Route>

            <Route path="/football-manager" exact>
                <FmPage />
            </Route>

            <Route path="/teams-api/:id" exact>
                <SingleTeamAPIPage />
            </Route>

            <Route path="/players-api/:id" exact>
                <SinglePlayerAPIPage />
            </Route>
            <Route path="/live-fixtures" exact>
                <FixturesAPIMainPage />
            </Route>
            <Route path="/live-fixtures/:id" exact>
                <FixturesAPIPage />
            </Route>
            <Route path="/live-fixtures/single/:id" exact>
                <SingleFixtureAPIPage />
            </Route>

            <Route path="/media">
                <MediaPage />
            </Route>
            <Route path="/albums/:id" exact>
                <SingleAlbumPage />
            </Route>
            <Route path="/login" exact>
                <AuthPage />
            </Route>
            <Route path="/profile">
                <ProfilePage />
            </Route>

            <Route path="/add-post" exact>
                <AddPost />
            </Route>

            <Route path="/innlegg/edit/:id" exact>
                <EditPost />
            </Route>

            <Route path="/edit-team/:id" exact>
                <EditTeamPage />
            </Route>

            <Route path="/edit-fixture/:id" exact>
                <EditFixturePage />
            </Route>

            <Route path="/edit-player/:id" exact>
                <PlayerDetails />
            </Route>

            <Route path="/add-transfer" exact>
                <AddTransfer />
            </Route>
            <Route path="/edit-transfer/:id" exact>
                <EditTransfer />
            </Route>

            <Route path="/api-dashboard" exact>
                <APIDashboardPage />
            </Route>

            <Route path="/hostcup" exact>
                <HostcupPage />
            </Route>
            <Route path="/hostcup/admin" exact>
                <HostcupDashboard />
            </Route>
            <Route path="/hostcup/admin/:id" exact>
                <SingleHostcupAdminFirebase />
            </Route>
            <Route path="/hostcupround/admin/:id" exact>
                <SingleRoundHostcupFirebasePage />
            </Route>

          </Switch>
          <Footer />
      </BrowserRouter>
      </DispatchContext.Provider>
      </StateContext.Provider>
    );

}

export default App;
